export const clampTokenUsagePercentage = (percentage: number) =>
  Math.min(Math.max(percentage, 0), 100);
